/* @jsx h */
import { defineComponent, h } from "vue";
import { OverviewPage } from "../Reports/subpages/Overview";
import { onMounted } from "vue";
import { setTitle } from "@lemmonhq/orders";
import { WeeklyHeatmapPage } from "../Reports/subpages/WeeklyHeatmap";
export const ManagerDashboardPage = defineComponent({
  name: "ManagerDashboardPage",
  setup() {
    onMounted(() => {
      setTitle("Dashboard");
    });
    return () => (
      <div class=" flex-1 h-full p-8 overflow-y-auto">
        <div style="" class="flex border  rounded-lg py-4 overflow-hidden">
          <WeeklyHeatmapPage />
        </div>
        <div class="flex overflow-hidden py-4 mb-4 ">
          <OverviewPage />
        </div>
      </div>
    );
  },
});
